/**
 * GoNOW API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2020-12-7
 * Contact: info@zero-spec.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
* The CreateCompanyRequest model module.
* @module model/CreateCompanyRequest
* @version 2020-12-7
*/
export default class CreateCompanyRequest {
    /**
    * Constructs a new <code>CreateCompanyRequest</code>.
    * 会社登録レスポンス
    * @alias module:model/CreateCompanyRequest
    * @class
    * @param companyName {String} 会社名
    * @param parentGroupId {Number} 親会社ID
    */

    constructor(companyName, parentGroupId) {
        
        
        this['companyName'] = companyName;
        this['parentGroupId'] = parentGroupId;
        
    }

    /**
    * Constructs a <code>CreateCompanyRequest</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/CreateCompanyRequest} obj Optional instance to populate.
    * @return {module:model/CreateCompanyRequest} The populated <code>CreateCompanyRequest</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CreateCompanyRequest();
                        
            
            if (data.hasOwnProperty('companyName')) {
                obj['companyName'] = ApiClient.convertToType(data['companyName'], 'String');
            }
            if (data.hasOwnProperty('parentGroupId')) {
                obj['parentGroupId'] = ApiClient.convertToType(data['parentGroupId'], 'Number');
            }
            if (data.hasOwnProperty('address')) {
                obj['address'] = ApiClient.convertToType(data['address'], 'String');
            }
            if (data.hasOwnProperty('tel')) {
                obj['tel'] = ApiClient.convertToType(data['tel'], 'String');
            }
            if (data.hasOwnProperty('remarks')) {
                obj['remarks'] = ApiClient.convertToType(data['remarks'], 'String');
            }
            if (data.hasOwnProperty('representativeName')) {
                obj['representativeName'] = ApiClient.convertToType(data['representativeName'], 'String');
            }
            if (data.hasOwnProperty('representativePassword')) {
                obj['representativePassword'] = ApiClient.convertToType(data['representativePassword'], 'String');
            }
        }
        return obj;
    }

    /**
    * 会社名
    * @member {String} companyName
    */
    'companyName' = undefined;
    /**
    * 親会社ID
    * @member {Number} parentGroupId
    */
    'parentGroupId' = undefined;
    /**
    * 住所
    * @member {String} address
    */
    'address' = undefined;
    /**
    * 電話番号
    * @member {String} tel
    */
    'tel' = undefined;
    /**
    * 備考
    * @member {String} remarks
    */
    'remarks' = undefined;
    /**
    * 代表氏名
    * @member {String} representativeName
    */
    'representativeName' = undefined;
    /**
    * 代表パスワード
    * @member {String} representativePassword
    */
    'representativePassword' = undefined;




}
